import { NgModule } from '@angular/core';
import { CityFeatureBrowserModule } from '@city/feature';

@NgModule({
  imports: [CityFeatureBrowserModule],
})
export class CityBrowserModule {}
